import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import auth from "../../../utils/auth";

const NoAuthRoute = () =>
    auth.getAccessToken() === null ? <Outlet /> : <Navigate to="/portfolio" />;

export default NoAuthRoute;
